import { ACTIVE_FILTERS } from '../actions/types'

const INITIAL_STATE = {
  filterList: null,
}

const filterReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTIVE_FILTERS:
      return { ...state, filterList: action.payload }
    default:
      return state
  }
}
export default filterReducer
